export const personalityTypes = [
  {
    id: 'panicked',
    name: 'Paniqué',
    description: 'Parle vite, très émotif, difficile à calmer',
    color: 'from-red-400 to-rose-500',
    icon: '😰'
  },
  {
    id: 'calm',
    name: 'Calme',
    description: 'Posé, donne des informations claires et précises',
    color: 'from-green-400 to-emerald-500',
    icon: '😌'
  },
  {
    id: 'annoyed',
    name: 'Irrité',
    description: 'Impatient, exigeant, potentiellement désagréable',
    color: 'from-orange-400 to-amber-500',
    icon: '😠'
  },
  {
    id: 'quiet',
    name: 'Peu bavard',
    description: 'Réponses courtes, faut insister pour les détails',
    color: 'from-blue-400 to-indigo-500',
    icon: '😐'
  },
  {
    id: 'confused',
    name: 'Confus',
    description: "Difficultés à s'exprimer, désorienté",
    color: 'from-purple-400 to-violet-500',
    icon: '😵'
  },
  {
    id: 'elderly',
    name: 'Personne âgée',
    description: 'Parle lentement, très détaillé, parfois répétitif',
    color: 'from-gray-400 to-slate-500',
    icon: '👴'
  },
  {
    id: 'child',
    name: 'Enfant/Adolescent',
    description: 'Effrayé, peut ne pas connaître les adresses',
    color: 'from-pink-400 to-rose-500',
    icon: '😢'
  },
  {
    id: 'hysterical',
    name: 'Hystérique',
    description: 'Pleure, très émotif, difficile à comprendre',
    color: 'from-red-500 to-pink-500',
    icon: '😭'
  },
  {
    id: 'suspicious',
    name: 'Méfiant',
    description: 'Ne fait pas facilement confiance, hésitant',
    color: 'from-yellow-400 to-orange-400',
    icon: '🤨'
  },
  {
    id: 'language_barrier',
    name: 'Barrière linguistique',
    description: 'Français approximatif, difficultés de communication',
    color: 'from-teal-400 to-cyan-500',
    icon: '🗣️'
  }
];

export const initialMessages = {
  panicked: "Aidez-moi! AIDEZ-MOI S'IL VOUS PLAÎT! Il faut que vous veniez tout de suite!",
  calm: "Bonjour, j'ai besoin des services d'urgence. Je vais vous expliquer la situation calmement.",
  annoyed: "Allô? Ça fait déjà 2 minutes que j'attends! C'est une urgence, dépêchez-vous!",
  quiet: 'Allô...',
  confused: 'Euh... allô? Je... je ne sais pas trop... il se passe quelque chose...',
  elderly: "Allô mon petit? Vous m'entendez bien? J'ai un petit problème ici...",
  child: "Allô? J'ai peur... est-ce que vous pouvez m'aider?",
  hysterical: "*pleure* Allô? *sanglote* Je... je ne sais plus quoi faire! *pleure*",
  suspicious: "C'est bien la police? Comment je sais que c'est vraiment vous?",
  language_barrier: 'Allô? Moi... moi avoir problème... vous aider moi?'
};

export const getInitialMessage = (personalityId) => {
  return initialMessages[personalityId] || "Allô? Aidez-moi s'il vous plaît!";
};

export const severityConfig = {
  critical: { color: 'bg-red-100 text-red-700 border-red-300', label: 'Critique' },
  high: { color: 'bg-orange-100 text-orange-700 border-orange-300', label: 'Élevé' },
  medium: { color: 'bg-amber-100 text-amber-700 border-amber-300', label: 'Moyen' },
  low: { color: 'bg-emerald-100 text-emerald-700 border-emerald-300', label: 'Faible' }
};

export const getSeverityColor = (severity) => severityConfig[severity]?.color || 'bg-gray-100 text-gray-700 border-gray-300';
export const getSeverityLabel = (severity) => severityConfig[severity]?.label || severity;
